<div
  class="d-flex align-items-center gap-3 my-4"
  *ngFor="let requirement of checkedRequirements"
>
  <i [ngClass]="requirement.isMatched ? 'fa-solid fa-check text-primary' : 'fa-solid fa-xmark text-light-gray'"></i
  >{{ requirement.name }}
</div>
